module.exports = __webpack_public_path__ + "811c8baeca3bb3329488f729979c1fbc.woff";